module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pback0-ab86fab0c4130c0aed3e2769d513e5c5.jpg";